import { combineReducers } from 'redux';

import reducerApp from 'index/AppReducer';
import reducerArticle from 'components/Article/ArticleReducer';
import reducerBannerVideo from 'screens/Collection/components/VideoBanner/components/BannerVideo/Reducer';
import reducerBlackoutDefinitionFetcher from 'components/BlackoutDefinitionFetcher/BlackoutDefinitionFetcherReducer';
import reducerBrowse from 'screens/Browse/BrowseReducer';
import reducerCanIAutoplay from 'components/CanIAutoplay/Reducer';
import reducerChannel from 'screens/Channel/Reducer';
import reducerCollection from 'screens/Collection/Reducer';
import reducerDebug from 'screens/Debug/DebugReducer';
import reducerEmailSubmissionForm from 'components/EmailSubmissionForm/EmailSubmissionFormReducer';
import reducerFind from 'screens/Find/FindReducer';
import reducerFooter from 'components/Footer/FooterReducer';
import reducerFooterUpsell from 'components/FooterUpsell/FooterUpsellReducer';
import reducerHoverMenu from 'components/Header/HoverMenu/HoverMenuReducer';
import reducerLatestEpisode from 'screens/LatestEpisode/LatestEpisodeReducer';
import reducerLive from 'screens/Live/LiveReducer';
import reducerNavSchedule from 'components/NavSchedule/NavScheduleReducer';
import reducerPanel from 'components/Panel/PanelReducer';
import reducerPersonality from 'screens/Personality/PersonalityReducer';
import reducerSeriesDetail from 'screens/ContentDetail/ContentDetailReducer';
import reducerSiteMap from 'screens/SiteMap/SiteMapReducer';
import reducerStartFreeTrial from 'components/FloatingStartFreeTrial/FloatingStartFreeTrial.reducer';
import reducerVideoModal from 'components/VideoModal/VideoModalReducer';
import reducerVideoPlayerGlobal from 'components/VideoPlayerGlobal/Reducer';
import reducerVideosTab from 'screens/ContentDetail/components/VideosTab/VideosTabReducer';
import reducerWatch from 'screens/Watch/WatchReducer';

const rootReducer = combineReducers({
  app: reducerApp,
  article: reducerArticle,
  bannerVideo: reducerBannerVideo,
  blackoutDefinitionFetcher: reducerBlackoutDefinitionFetcher,
  browse: reducerBrowse,
  canIAutoplay: reducerCanIAutoplay,
  channel: reducerChannel,
  collection: reducerCollection,
  debug: reducerDebug,
  emailSubmissionForm: reducerEmailSubmissionForm,
  footer: reducerFooter,
  footerUpsell: reducerFooterUpsell,
  globalVideo: reducerVideoPlayerGlobal,
  hoverMenu: reducerHoverMenu,
  latestEpisode: reducerLatestEpisode,
  live: reducerLive,
  navSchedule: reducerNavSchedule,
  panel: reducerPanel,
  personality: reducerPersonality,
  find: reducerFind,
  seriesDetail: reducerSeriesDetail,
  siteMap: reducerSiteMap,
  videoModal: reducerVideoModal,
  videosTab: reducerVideosTab,
  watch: reducerWatch,
  startFreeTrial: reducerStartFreeTrial,
});

export default rootReducer;
